// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const environmentCommonValues = {
  status: {
    draft: "Draft",
    active: "Active",
    published: "Published",
    archived: "Archived",
    disabled: "Disabled",
  },
  visibility: {
    private: "Private",
    shared: "Shared",
  },
  values: {
    undefinedBoolean: "Undefined boolean value",
  },
  usageTypes: {
    target_device: "Target Device",
    template_source: "Template Source",
  },
  architectures: {
    x86_64: "x86_64",
    arm64: "ARM64",
    i386: "i386",
    other: "Other",
  },
} as const;
